type FillInGapExerciseIdentity = {
  content: string;
  correctAnswer: string;
  languageCode?: string;
};

const GAP_PATTERN = /_{3,}/g;

export function countFillInGapBlanks(sentence: string): number {
  return sentence.match(GAP_PATTERN)?.length ?? 0;
}

export function hasExactlyOneFillInGapBlank(sentence: string): boolean {
  return countFillInGapBlanks(sentence) === 1;
}

function normalizeFingerprintPart(value: string): string {
  return value.trim().toLocaleLowerCase().replace(/\s+/g, " ");
}

export function createFillInGapExerciseFingerprint(exercise: FillInGapExerciseIdentity): string {
  return [exercise.languageCode || "", exercise.content, exercise.correctAnswer]
    .map(normalizeFingerprintPart)
    .join("|");
}
